/**
 * 申请类型
 */
export function applicationTypes() {
  return {
    'PROFESSOR_TEACHER': '专家老师体验申请',
    'DIGITAL_INTELLIGENCE': '数智老师体验申请',
    'COOPERATIVE_ORGANIZATION': '合作机构申请',
    'COOPERATIVE_PROFESSOR': '合作专家申请',
    'PUBLIC_BENEFIT_ONLINE': '公益在线申请'
  }
}



// WEBPACK FOOTER //
// ./src/utils/enums.js